import { AnyAction } from '@reduxjs/toolkit';
import { GetOrganizationsWithCustomersRoutine } from '~modules/Companies/redux-routines';
import type { TOrganizationsWithCustomersState } from '../interfaces';

export const initialState: TOrganizationsWithCustomersState = {
  data: [],
  error: null,
  isLoading: false,
};

export const organizationsWithCustomersReducer = (
  state: TOrganizationsWithCustomersState = initialState,
  action: AnyAction,
): TOrganizationsWithCustomersState => {
  switch (action.type) {
    case GetOrganizationsWithCustomersRoutine.REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case GetOrganizationsWithCustomersRoutine.SUCCESS: {
      return {
        ...state,
        data: GetOrganizationsWithCustomersRoutine.getSuccessPayload(action),
        isLoading: false,
      };
    }
    case GetOrganizationsWithCustomersRoutine.FAILURE: {
      return {
        ...state,
        error: GetOrganizationsWithCustomersRoutine.getFailurePayload(action),
        isLoading: false,
      };
    }
    default:
      return state;
  }
};
